export default {
    'plan-simulator': () => import(/* webpackChunkName: "plan-simulator" */ './components/PlanSimulator.vue'),
    'dashboard-admin': () => import(/* webpackChunkName: "dashboard-admin" */ './components/Admin/Dash/DashboardAdmin.vue'),
  };
